<template>
  <div>
    <TopNav/>
    <div class="container mt-4" >
      <h2 class="title">Patient Details</h2>
      <p>Manage and track all patient records</p>
      <div class="card p-4 pb-0 mb-4">
        <div class="input-group w-100">
          <div class="col-12">
            <div class="row justify-content-between">
              <h3 class="col-6">{{ patientName }}</h3>
              <button class="btn btn-outline-primary btn-sm col-2" @click="editPatientModal()">
                  Edit
              </button>
            </div>
            <p class="text-muted">Patient Id: {{ patientId }}</p>
            <p class="text-muted">EHR Id: {{ ehrId }}</p>
            <div class="row">
              <p class="col-3">Date of Birth : <strong>{{DOB  }}</strong></p>
              <p class="col-3">Past Encounters Number: <strong>{{encounterNumber  }}</strong></p>
              <p class="col-3">Phone Number: <strong>{{phoneNumber  }}</strong></p>         
            </div>
          </div> 
        </div>
      </div>
      <div class="card px-4">
        <div  class="mt-3 w-100 ">
          <div>
            <h5 v-if="( PatientsResult.length > 0 )">Patients ({{PatientsResult.length }}) </h5>
            <h5 v-else >Encounter History ({{ patientEncounters }}) </h5>
            <p>All medical encounters for <strong>{{ patientName }}</strong></p>
          </div>
          <EasyDataTable :headers="headers" :items="encounters" :loading="loading" buttons-pagination :rows-per-page="10" :fixed-header="true" :height="400">
            <template #item-status="{ status }">
              <span :class="status ? 'text-warning fw-bold' : 'text-success fw-bold'">
                {{ status ? 'Draft' : 'Completed' }}
              </span>
            </template>
            <template #item-duration="{ duration }">
              <span> {{ duration  }} min</span>
            </template>
            <template #item-actions="{ id }">
              <button class="btn btn-sm btn-outline-info" @click="goToDetails(id)">
                View Details
              </button>
            </template>
            <template #empty>
                <div v-if="!loading">No data found.</div>
              </template>
          </EasyDataTable>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted , computed } from 'vue';
import {useRoute} from 'vue-router';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import TopNav from '../layouts/topNav.vue';
import { useModalManager } from '@/composables/useModalManager'
import EditPatientModal from '@/components/modals/editingPatient.vue'
import { getPatientByIdService } from "@/services/api/patientService";
import { getEncounterByIdService } from "@/services/api/encounterService";

const { openAsPromise } = useModalManager()
const route = useRoute();
const router = useRouter();
const store = useStore();

const PatientsResult = ref([]);
const patientName = ref();
const DOB = ref('');
const patientId = computed(() =>  route.params.id);
const encounterNumber = ref('')
const patientEncounters = ref('')
const encounters = ref([])
const ehrId = ref('')
const phoneNumber = ref('')

const selectedPatient = ref(null);
const editForm = ref({ name: "", phone_number: "", date_of_birth: "" });

const saveError = ref("");
const loading = ref(false)

const headers = [
  { text: "ID", value: "id", sortable: true  },
  { text: "Date", value: "date", sortable: true  },
  { text: "Duration", value: "duration", sortable: true  },
  { text: "Status", value: "Status", sortable: true  },
  { text: "Encounter Type", value: "encounter_type", sortable: true  },
  { text: "Actions", value: "actions" },
];

onMounted(() => { 
  getPatientById();
  getEncounterById();
});

const getPatientById = async () => {
  const result = await getPatientByIdService(patientId.value);
  selectedPatient.value= result
  DOB.value = result.date_of_birth;
  patientName.value = result.name
  encounterNumber.value = result.number_of_encounters
  phoneNumber.value = result.phone_number
  ehrId.value = result.ehr_id
};
const getEncounterById = async () => {
  const response = await getEncounterByIdService(Number(patientId.value));
  const result = response;
  encounters.value  = result.map(e => ({
    id: e.id,
    date: e.created_at,
    status: e.is_draft,
    duration: e.duration ,
    encounter_type: e.encounter_type,
  }));
  patientEncounters.value = result.length
};

const goToDetails = (topicId) => {
  const data = { view: 'details' };
  store.commit('setTopicId', topicId);
  store.commit('setPatientId', patientId.value);
  store.dispatch('navigation/saveNavigationData', data);
  router.push({ name: 'encounter' });
};

const openEditModal = async () => {
  editForm.value = {
    name: selectedPatient.value.name ?? "",
    phone_number: selectedPatient.value.phone_number ?? "",
    date_of_birth: (selectedPatient.value.date_of_birth ?? "").slice(0, 10),
  };
  saveError.value = "";
};

const editPatientModal = async () => {
  console.log(selectedPatient.value)
  openEditModal(); // prepare form
  const result = await openAsPromise({
    component: EditPatientModal,
    props: {
      selectedPatient: selectedPatient.value,
      editForm: editForm.value,
      patientId: patientId.value,
    }
  });
  if (result?.updated) {
    getPatientById();
  }
}
</script>

<style scoped>
.container{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 5rem;
}
.card{
  width: 75%;
}
.form-check-input:checked {
  background-color: #518db1 !important;
  border-color: #518db1 !important;
}

.title {
  font-weight: 600;
  text-align: center;
  color: #518DB1 ;
}

.input-group {
  margin-bottom: 15px;
  width: 40%;
}

.input-label {
  font-size: 14px;
  margin-bottom: 5px;
  display: block;
  color: #555;
}

.input-field {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 16px;
}

.route-options {
  margin-bottom: 20px;
}

.route-label {
  display: block;
  margin-bottom: 10px;
  font-size: 14px;
  cursor: pointer;
  position: relative;
  padding-left: 15px;
}

.route-radio {
  position: absolute;
}

.modal-actions {
  display: flex;
  justify-content: space-between;
}

.submit-btn {
  flex: 1;
  padding: 10px;
  border: none;
  border-radius: 50px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
  width: 10rem;
  background-color: #518DB1;
  color: white;
  margin-right: 10px;
}
.input-field{
  border-radius: 8px !important;
}
.addBtn{
  background-color: #FFF
}
.addBtn:hover{
  background-color:#518DB1;
}
@media (max-width: 976px) {
  .card{
    width: 100%;
  }
}
</style>